export function constables() {

    return {breakpoint:880,
            times: 500,
            timem: 800,
            timel: 2000};

}

export function resize() {

    let vw = window.innerWidth;
    return vw;

}